module.exports = __webpack_public_path__ + "img/go.9f3449d9.svg";